const imageBasePath =
  process.env.NODE_ENV === "development"
    ? `http://localhost:7250`
    : `https://api.${process.env.REACT_APP_DOMAIN}`;

export default imageBasePath;
